export default __webpack_public_path__ + "static/media/feature1.1dbbac7a.png";